import { AudioPlayerElement } from '@/audioPlayerElement';
import type { AudioPlayerOptions } from '@/audioPlayerElement/AudioPlayer.type';
import type { RSSFeedDataPodcastAppleEpisode, RSSFeedDataPodcastItem, WebTheme } from '@/types';

import { RSS_FEED_EPISODE_DEFAULTS } from './constants';

type AudioPlayerProps = {
  podcastEpisode: RSSFeedDataPodcastItem;
  applePodcastEpisode?: RSSFeedDataPodcastAppleEpisode;
  theme: WebTheme;
  className?: string;
  options?: AudioPlayerOptions;
};

export const PodcastAudioPlayer = ({
  podcastEpisode,
  applePodcastEpisode,
  theme,
  className,
  options,
}: AudioPlayerProps) => {
  const episodeImageURL = podcastEpisode?.['itunes:image']?.['@href'] || applePodcastEpisode?.artworkUrl600 || '';
  const themeTextColor = theme.text_on_background_color || RSS_FEED_EPISODE_DEFAULTS.titleTextColor;

  return (
    <AudioPlayerElement
      audioUrl={podcastEpisode.enclosure['@url']}
      audioType={podcastEpisode.enclosure['@type']}
      thumbnailUrl={episodeImageURL}
      title={podcastEpisode.title}
      className={className}
      options={{
        playerMode: 'classic',
        textColor: themeTextColor,
        ...options,
      }}
    />
  );
};
